<div class="notifications-overlay" (click)="closeNotifications()"></div>

<div class="notifications-modal">
  <div class="notifications-header">
    <h5 class="title">
      <mat-icon [svgIcon]="'bell-point'" class="notification-icon"></mat-icon>
      {{headerText}}
    </h5>
    <button class="no-style close-btn" (click)="closeNotifications()">
      <mat-icon [svgIcon]="'close'" class="square-icon close-icon"></mat-icon>
    </button>
  </div>

  <app-messages [messages]="messages" />
</div>
